import { render, staticRenderFns } from "./english-small-test-end.vue?vue&type=template&id=4892a0be&scoped=true&"
import script from "./english-small-test-end.vue?vue&type=script&lang=js&"
export * from "./english-small-test-end.vue?vue&type=script&lang=js&"
import style0 from "./english-small-test-end.vue?vue&type=style&index=0&id=4892a0be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4892a0be",
  null
  
)

export default component.exports